import { createContext, Dispatch, ReactNode, useContext, useReducer } from 'react';

type SensorFusionLookupContextState = {
  remotasksFrontendUrl?: string;
  scaleDashboardFrontendUrl?: string;
};

const defaultInitialState: SensorFusionLookupContextState = {};

enum SensorFusionLookupReducerActionType {
  SET_REMOTASKS_FRONTEND_URL,
  SET_SCALE_DASHBOARD_FRONTEND_URL,
}

type SetRemotasksFrontendUrlAction = {
  type: SensorFusionLookupReducerActionType.SET_REMOTASKS_FRONTEND_URL;
  value: string;
};

type SetScaleDashboardFrontendUrlAction = {
  type: SensorFusionLookupReducerActionType.SET_SCALE_DASHBOARD_FRONTEND_URL;
  value: string;
};

type SensorFusionLookupReducerAction =
  | SetRemotasksFrontendUrlAction
  | SetScaleDashboardFrontendUrlAction;

const reducer = (
  state: SensorFusionLookupContextState,
  action: SensorFusionLookupReducerAction,
): SensorFusionLookupContextState => {
  const { type } = action;
  switch (type) {
    case SensorFusionLookupReducerActionType.SET_REMOTASKS_FRONTEND_URL: {
      return {
        ...state,
        remotasksFrontendUrl: action.value,
      };
    }
    case SensorFusionLookupReducerActionType.SET_SCALE_DASHBOARD_FRONTEND_URL: {
      return {
        ...state,
        scaleDashboardFrontendUrl: action.value,
      };
    }
    default: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      throw Error('Unknown action: ' + type);
    }
  }
};

const SensorFusionLookupContext = createContext<SensorFusionLookupContextState | undefined>(
  undefined,
);

const SensorFusionLookupDispatchContext = createContext<
  Dispatch<SensorFusionLookupReducerAction> | undefined
>(undefined);

export const SensorFusionLookupProvider = ({
  children,
  initialState,
}: {
  children: ReactNode;
  initialState?: SensorFusionLookupContextState;
}) => {
  const [state, dispatch] = useReducer(reducer, initialState ?? defaultInitialState);

  return (
    <SensorFusionLookupContext.Provider value={state}>
      <SensorFusionLookupDispatchContext.Provider value={dispatch}>
        {children}
      </SensorFusionLookupDispatchContext.Provider>
    </SensorFusionLookupContext.Provider>
  );
};

export const useSensorFusionLookupContext = () => {
  return useContext(SensorFusionLookupContext);
};
